import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';
import { TDevice } from '@/features/devices/schemas/devices.schemas.ts';

export const useGetPlantDevicesQuery = ({
  plantId,
  enabled = true,
}: {
  plantId?: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: ['plants', plantId, 'devices'],
    queryFn: async () => {
      const { data } = await client.get<{ body: TDevice[] }>(`/plants/${plantId}/devices`);

      return data.body;
    },
    retry: 1,
    enabled,
  });
};
